import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'

import { onUpdateStep } from '../../store/modules/guidedSearch.module'
import { setActiveFilterIds } from '../../store/modules/filters.module'
import {
  CheckboxGroup,
  RadioButtonGroup,
  Slider,
  MultiselectDropdown
} from '../../components'
import keywords from '../../keywords'
import './GuidedSearchQuestionHandler.sass'


function renderQuestionGroup(filter, activeFilterIds, setActiveFilterIds, onUpdateStep) {
  const props = {
    options: filter.filter_terms,
    filterId: filter.id,
    activeFilterIds,
    setActiveFilterIds,
    onUpdate: onUpdateStep
  }

  switch (filter.filter_type) {

    case keywords.checkbox:
      return <CheckboxGroup {...props} />

    case keywords.radio:
      return <RadioButtonGroup {...props} />

    case keywords.slider:
      return <Slider {...props} />

    case keywords.multiselect: {
      const multiselectDropdowns = filter.filter_terms.map(filterTerm =>
        <MultiselectDropdown
          activeFilterIds={activeFilterIds}
          setActiveFilterIds={setActiveFilterIds}
          onUpdate={onUpdateStep}
          options={filterTerm.children}
          title={filterTerm.name}
          parentId={filterTerm.id}
          displayTextFilter={filter.enable_search_filter}
          additionalFilters={filterTerm.additional_filters}
          key={filterTerm.id}
          className="multiselect-guided-search"
        />
      )

      return <div className="multiselect-dropdowns-wrapper">{multiselectDropdowns}</div>
    }

    default:
      return null
  }
}

const GuidedSearchQuestionHandler = props => {
  const { filter, activeFilterIds, setActiveFilterIds, onUpdateStep } = props

  return renderQuestionGroup(filter, activeFilterIds, setActiveFilterIds, onUpdateStep)
}

const mapStateToProps = state => ({
  activeFilterIds: state.filters.activeFilterIds
})

GuidedSearchQuestionHandler.propTypes = {
  filter: PropTypes.shape({
    filter_terms: PropTypes.array,
    filter_type: PropTypes.string,
    id: PropTypes.number
  }),
  onUpdateStep: PropTypes.func,
  setActiveFilterIds: PropTypes.func,
  activeFilterIds: PropTypes.array
}

export default connect(mapStateToProps, { onUpdateStep, setActiveFilterIds })(GuidedSearchQuestionHandler)
